var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-col',{staticClass:"w-100",attrs:{"lg":"12"}},[_c('m-single-lesson-1',{staticClass:"ml-auto mt-5 mr-auto"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }